import { Dispatch, SetStateAction } from 'react'

import { ArticleSearchCondition } from '@/common/api/modules/articles'
import { useSiteOperatorListApi } from '@/common/api/modules/siteOperator'
import {
  ARTICLE_CREATION_SOURCE_CHOICES,
  articleStatusChoices
} from '@/common/app/modules/media/article'
import { useSiteId } from '@/common/app/site'

import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import DisclosureSortRadioSelect from '@/components/view/molecules/disclosure/DisclosureSortRadioSelect'

interface Props {
  condition: ArticleSearchCondition
  setCondition: Dispatch<SetStateAction<ArticleSearchCondition>>
  enableArticleUpload: boolean
}

// 記事一覧の検索条件（作成種別・記事ステータス・担当者）
const ArticleSearchConditionField = ({ condition, setCondition, enableArticleUpload }: Props) => {
  const siteId = useSiteId()
  const { data: operators } = useSiteOperatorListApi({ site_id: siteId })

  return (
    <SearchConditionAreaContent>
      <SortButtonList>
        <DisclosureSortRadioSelect
          name='creationSource'
          currentValue={condition.creationSource}
          choices={ARTICLE_CREATION_SOURCE_CHOICES}
          setCondition={setCondition}
        >
          作成種別
        </DisclosureSortRadioSelect>
        <DisclosureSortRadioSelect
          name='status'
          currentValue={condition.status}
          choices={articleStatusChoices(enableArticleUpload)}
          setCondition={setCondition}
        >
          記事ステータス
        </DisclosureSortRadioSelect>
        <DisclosureSortRadioSelect
          name='siteOperatorId'
          currentValue={condition.siteOperatorId}
          choices={(operators ?? []).map((o) => ({ name: o.name, value: o.id }))}
          setCondition={setCondition}
        >
          担当者
        </DisclosureSortRadioSelect>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default ArticleSearchConditionField
